import React from 'react';
import { records as appStorageRecords, constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';
import {
  IconIosFill,
  IconAndroidFill,
} from '@saucelabs/ds-icons';
import { Tooltip } from '@saucelabs/ds-tooltip';

const {
  APP_STORAGE_KIND,
  APP_STORAGE_PRETTY_PLATFORM,
} = appStorageConstants;

const KindIcon = Object.freeze({
  [APP_STORAGE_KIND.IOS]: IconIosFill,
  [APP_STORAGE_KIND.ANDROID]: IconAndroidFill,
  [APP_STORAGE_KIND.OTHER]: () => (<></>),
});

type TableCellOsProps = {
  group: appStorageRecords.AppStorageGroup,
}

const TableCellOs: React.FC<TableCellOsProps> = ({ group }) => {
  const Icon = KindIcon[group.recent.kind];

  return (
    <div>
      <Tooltip
        placement="top"
        title={APP_STORAGE_PRETTY_PLATFORM[group.recent.kind]}
      >
        <span className="py-0.5">
          <Icon className="w-2 h-2 text-gray-500 fill-current" />
        </span>
      </Tooltip>
    </div>
  );
};

export default TableCellOs;
